import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { importVehicleCatalog } from "@/utils/importVehicleCatalog";
import { Database, Loader2 } from "lucide-react";

const ImportVehicleCatalog = () => {
  const [isImporting, setIsImporting] = useState(false);
  const [logs, setLogs] = useState<string[]>([]);

  const handleImport = async () => {
    setIsImporting(true);
    setLogs([]);

    const success = await importVehicleCatalog(
      (message) => {
        setLogs((prev) => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
      },
      undefined, // Import all packages
      true // Clear all existing data first
    );

    setIsImporting(false);
  };

  return (
    <div className="container mx-auto p-6 max-w-4xl">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <Database className="h-6 w-6" />
            <CardTitle>Import Vehicle Catalog</CardTitle>
          </div>
          <CardDescription>
            Import vehicle data from CSV files into the database. This will replace all existing vehicle catalog data.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <h3 className="font-semibold">Package Files to Import:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
              <li>Asian vehicles (3,551 records)</li>
              <li>Domestic vehicles (3,733 records)</li>
              <li>Diesel vehicles (591 records)</li>
              <li>European vehicles (3,042 records)</li>
              <li>Electric vehicles (334 records)</li>
              <li>Exotic/Supercar vehicles (864 records)</li>
            </ul>
          </div>

          <Button
            onClick={handleImport}
            disabled={isImporting}
            className="w-full"
          >
            {isImporting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isImporting ? "Importing..." : "Start Import"}
          </Button>

          {logs.length > 0 && (
            <div className="space-y-2">
              <h3 className="font-semibold">Import Log:</h3>
              <ScrollArea className="h-64 w-full rounded-md border p-4">
                <div className="space-y-1">
                  {logs.map((log, index) => (
                    <div key={index} className="text-sm font-mono">
                      {log}
                    </div>
                  ))}
                </div>
              </ScrollArea>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ImportVehicleCatalog;
